import { useContext } from "react";
import { useSelector } from "react-redux";

import { Boundaries } from "@planzone/core";
import { CoreContext } from "../context";

interface ViewModel {
  isRequestSuccess: boolean;
  isRequestFailure: boolean;
  isRequestPending: boolean;
  createDocument(request: Boundaries["createDocument"]["request"]): void;
}

function useCreateDocument(): ViewModel {
  const { selector, core } = useContext(CoreContext);

  return {
    isRequestPending: useSelector(selector.isCreateDocumentRequestPending),
    isRequestSuccess: useSelector(selector.isCreateDocumentRequestSuccess),
    isRequestFailure: useSelector(selector.isCreateDocumentRequestFailure),
    createDocument: core.createDocument,
  };
}

export { useCreateDocument };
